import Vue from 'vue';

const getDateFromTimestamp = (timestamp) => {
  timestamp = parseInt(timestamp);
  const date = new Date(timestamp);
  const monthNames = [
    "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
  ];

  const dateWithFullMonthName = monthNames[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
  return dateWithFullMonthName;
};

const globalState = {};

const globalActions = {
  showLoginDialog({ commit }) {
    commit('showLogin', true);
    history.pushState(null, null, "#login");
  },
  hideLoginDialog({ commit }) {
    commit('showLogin', false);
  },
  setMessage({ commit }, message) {
    commit('setMessage', message);
  },
};

const globalGetters = {
  getConversationIds: (state) => {

    return Object.entries(state.lastMessageTimestampsMap).
    sort(([id1, timestamp1], [id2, timestamp2]) => timestamp2 - timestamp1).
    map(([id, timestamp]) => id);
  },
  conversationsState: (state) => {
    if (Object.keys(state.lastMessageTimestampsMap).length) {
      return 'loaded';
    } else {
      return 'empty';
    }
  },
  conversations: (state) => {
    const chats = [];
    for (const id in state.conversationIds) {
      chats.push(id);
    }
    return chats;
  },
  getMyMessages: (state) => {
    let lastDate = "";
    let messageDate = "";
    const messages = [];
    for (let id in state.myMessages) {
      const message = state.myMessages[id];
      messageDate = getDateFromTimestamp(message.timestamp);
      if (messageDate !== lastDate) {
        lastDate = messageDate;
        // messages.push({ type: "dateSeperator", date: messageDate });
      }
      // console.log(message.timestamp);
      // console.log(lastDate);
      messages.push(message);
    }

    return messages;
  },
};

const globalMutations = {
  setMessage(state, message) {
    state.message = message;
  },
  showLogin(state, bool) {
    state.showLogin = bool;
  },
};



export {
  globalState,
  globalActions,
  globalGetters,
  globalMutations
};
